/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'GoalPanel.header.title': 'Cíl',
  'goal-panel.generic-error.description': 'Zkontrolujte připojení k internetu a zkuste to znovu.',
  'goal-panel.generic-error.title': 'Něco se pokazilo',
  'goal-panel.goal-panel-expand-field-button.show-less-collapsed-label': 'Zobrazit další pole',
  'goal-panel.goal-panel-expand-field-button.show-more-collapsed-label': 'Zobrazit méně',
  'goal-panel.goal-panel-tabs.about-tab-title': 'Informace',
  'goal-panel.goal-panel-tabs.jira-align-title': 'Jira Align',
  'goal-panel.goal-panel-tabs.jira-title': 'Jira',
  'goal-panel.goal-panel-tabs.projects-title': 'Projekty',
  'goal-panel.goal-panel-tabs.updates-tab-title': 'Aktualizace',
  'goal-panel.goal-title.edit-button-label': 'Upravit název cíle',
  'goal-panel.goal-title.update-error-description': 'Aktualizace obsahu projektu {goalName} se nezdařila',
  'goal-panel.goal-title.update-error-title': 'Něco se pokazilo',
  'goal-panel.goal-title.validation-message': 'Zadejte název svého cíle.',
};
